module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/moon.svg?0c591c54f236720e70349852aa0c05ec";